module.exports = __webpack_public_path__ + "img/img001.ee96da87.png";